import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const MissingAdContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 40px 0;
  background-color: ${({ theme }) => theme.palette.primary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-right: 15px;
    padding-left: 15px;
    margin-bottom: 5px;
    border-radius: 0 0 21px 21px;
  }
`;

export const MissingAdTitle = styled(Typography.Header).attrs({
  $variant: '0',
})``;

export const MissingAdText = styled(Typography.Caption).attrs({
  $variant: '1',
})`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 16px;
  }
`;
